<template>
  <!-- /.panel-heading -->
  <div class="panel-body deposit-options">
    <div class="row">
      <div class="col-md-offset-3 col-md-6 col-lg-offset-3 col-lg-6 col-xl-offset-3 col-xl-6">
        <div class="panel panel-default panel-choose">
          <div class="bank-table" v-for="o in options.pSPConfig.contentJson">
            <div class="row header">
              <div class="col-md-12">
                <img v-if="o.header.logo_url != ''" :src="o.header.logo_url">
                <p v-if="o.header.title != ''">{{o.header.title}}</p>
              </div>
            </div>
            <div class="row" v-for="i in o.rows">
              <div class="col-md-6">
                <span>{{i.col_l}}</span>
              </div>
              <div class="col-md-6">{{i.col_r}}</div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <p>&nbsp;</p>
                <p>{{o.footer.description}}</p>
                <a
                  v-if="o.footer.url != ''"
                  :href="o.footer.url"
                  target="_blank"
                >{{$t('shared.buttons.download_pdf')}}</a>
              </div>
            </div>
          </div>
        </div>
        <!-- /.panel-body -->
      </div>
    </div>
    <div class="form-group row buttons-r">
      <div class="col-xs-12 col-md-offset-8 col-md-4">
        <button
          type="button"
          v-on:click="goToStep('payment')"
          class="btn btn-default mrg-b-25"
        >{{$t('shared.buttons.prev')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PacificPrivateBankOption",
  props: ["options"],
  methods: {
    goToStep(step) {
      EventBus.$emit("onGoToStep", step);
    }
  },
  validations: {
    options: {
      pSPConfig: {
        required
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/BankDetailsDepositOption.vue